module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0857.d14488cb.jpg";